// extracted by mini-css-extract-plugin
module.exports = {"button":"TransferOptionsButton_button__vNQGj","focus-visible":"TransferOptionsButton_focus-visible__tD7s5"};